export const LIMITED_TIME_SPECIAL = Symbol('LIMITED_TIME_SPECIAL');
export const LAST_ACT = Symbol('LAST_ACT');
export const CLEARANCE = Symbol('CLEARANCE');
export const TODAY_ONLY = Symbol('TODAY_ONLY');
export const BLACK_FRIDAY_DEAL = Symbol('BLACK_FRIDAY_DEAL');
export const CYBER_MONDAY_DEAL = Symbol('CYBER_MONDAY_DEAL');
export const LOWEST_PRICE_OF_THE_SEASON = Symbol('LOWEST_PRICE_OF_THE_SEASON');
export const WITH_CODE = Symbol('WITH_CODE');

export const PROMO_TYPES_MAP_BY_TEXT = {
  'Black Friday Deal': BLACK_FRIDAY_DEAL,
  'Cyber Monday Deal': CYBER_MONDAY_DEAL,
  'Limited-Time Special': LIMITED_TIME_SPECIAL,
  'LAST ACT': LAST_ACT,
  Clearance: CLEARANCE,
  'Today Only': TODAY_ONLY,
  'Our Lowest Price of the Season': LOWEST_PRICE_OF_THE_SEASON,
  // WITH_CODE is a special case, it's not included in the map and handled separately
};
